import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * 短信营销跳转页面
 * 
 * 用途：短信中携带本页面链接（ICP备案域名），页面加载后自动跳转到微信小程序 URL Scheme。
 * 
 * 流程：短信 → 本H5页面（ICP备案域名） → URL Scheme → 微信小程序
 * 
 * 支持通过 URL 参数 `scheme` 动态指定跳转目标，例如：
 *   /marketing/children?scheme=weixin://dl/business/?t=xxxxx
 * 
 * 如果未提供 scheme 参数，则使用默认的 URL Scheme。
 */

const DEFAULT_SCHEME = 'weixin://dl/business/?t=B4CEJUTBV7d';

const MarketingChildren: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const scheme = searchParams.get('scheme') || DEFAULT_SCHEME;
    window.location.href = scheme;
  }, [searchParams]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#333',
      backgroundColor: '#f5f5f5',
    }}>
      <p style={{ fontSize: '16px' }}>正在跳转到微信小程序...</p>
      <p style={{ fontSize: '13px', color: '#999', marginTop: '12px' }}>
        如果没有自动跳转，请确保已安装微信
      </p>
    </div>
  );
};

export default MarketingChildren;
